var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { mapState } from 'vuex';
import moment from 'moment';
import { setTimeout } from 'timers';
import { toYuan, toFen } from '../../utils/unit-conversion';
import { amountType, deductMode, repayStatus } from '../../enum/common';
import request from '../../utils/request';
import table from '../../components/console-common/table.vue';
import commonVideo from '../../components/console-common/common-video.vue';
import eventBus from '../../utils/fresh-table';
import cookie from '../../cookie/cookie';
export default Vue.extend({
    name: 'login',
    components: {
        'repayment-list': table,
        'el-common-video': commonVideo,
    },
    computed: __assign({}, mapState('info', {
        cityList: 'cityList',
        signCompanyList: 'signCompanyList',
        settleCompanyList: 'settleCompanyList',
    }), { waitReturn: function () {
            return toYuan(this.currentData.amount - this.currentData.paidAmount);
        },
        isActive: function () {
            var _a = this.currentData, deductMode = _a.deductMode, activeState = _a.activeState;
            return ((deductMode === 'DAY_AVERAGE' || deductMode === 'DAY_GREED') &&
                activeState === 'ACTIVE');
        } }),
    data: function () {
        var _this = this;
        var info = this.$store.state.info;
        var checkIsNumber1 = function (rule, value, callback) {
            var res = /^\s*(\d{1,6}|\d{1,6}[.]{1}[0-9]{1,2})\s*$/;
            var activeState = _this.currentData.activeState;
            if ((_this.isActive || activeState === 'INACTIVE') && value === '0') {
                return callback();
            }
            if (value <= 0) {
                return callback(new Error('数字必须大于0'));
            }
            if (!res.test(value)) {
                return callback(new Error('最多6位整数，2位小数'));
            }
            if (value < toYuan(_this.paidAmount)) {
                return callback(new Error('金额不小于已还金额'));
            }
            return callback();
        };
        var checkIsNumbers = function (rule, value, callback) {
            var res = /^\s*(\d{1,6}|\d{1,6}[.]{1}[0-9]{1,2})\s*$/;
            if (value <= 0) {
                return callback(new Error('数字必须大于0'));
            }
            if (!res.test(value)) {
                return callback(new Error('最多6位整数，2位小数'));
            }
            if (value > _this.waitReturn) {
                return callback(new Error('还款金额不超过待还金额'));
            }
            return callback();
        };
        var isvalidatecontractTime = function (rule, value, callback) {
            if (value[0] === null ||
                value[0] === undefined ||
                value[0] === '' ||
                value[1] === null ||
                value[1] === undefined ||
                value[1] === '') {
                return callback(new Error('请选择有效期'));
            }
            else {
                if (Date.parse(value[0]) > Date.parse(value[1])) {
                    return callback(new Error('开始时间不大于结束时间'));
                }
                else {
                    callback();
                }
            }
        };
        var repaymentDate = function (rule, value, callback) {
            var now = new Date();
            if (Date.parse(value) >
                new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime()) {
                return callback(new Error('还款时间不能大于今天'));
            }
            return callback();
        };
        return {
            dialogFormVisible: false,
            opeBtnActive: 'all',
            merchantId: '',
            currentData: {},
            otherParam: {},
            preFilledParam: {},
            usernameZh: '',
            stopDialog: false,
            stopStepActive: 1,
            stopStepInnerActive: 1,
            amountTips: true,
            // 已还金额
            paidAmount: 0,
            form: {
                name: '',
                region: '',
                date1: '',
                date2: '',
                delivery: false,
                type: [],
                resource: '',
                desc: '',
            },
            editForm: {
                amountTypeText: '',
                date: [],
                amount: '',
                mode: '',
                stopReason: '',
            },
            stopForm: {},
            option: [
                {
                    value: 'DAY_AVERAGE',
                    label: '日扣平均模式',
                    disabled: false,
                },
                {
                    value: 'DAY_GREED',
                    label: '日扣优先模式',
                    disabled: false,
                },
                {
                    value: 'ACTIVE',
                    label: '主动还款',
                    disabled: false,
                },
            ],
            editRules: {
                mode: [
                    { required: true, message: '请选择扣款模式', trigger: 'change' },
                ],
                amount: [
                    { required: true, message: '请输入扣款金额', trigger: 'blur' },
                    { required: true, validator: checkIsNumber1, trigger: 'blur' },
                ],
                date: [
                    {
                        required: true,
                        validator: isvalidatecontractTime,
                        trigger: 'change',
                    },
                ],
            },
            stopRules: {
                stopAmount: [
                    { required: true, message: '请输入扣款金额', trigger: 'blur' },
                    { required: true, validator: checkIsNumbers, trigger: 'blur' },
                ],
                date: [
                    { required: true, message: '请输入还款时间', trigger: 'change' },
                    { required: true, validator: repaymentDate, trigger: 'change' },
                ],
                reason: [
                    { required: true, message: '请输入停用原因', trigger: 'change' },
                ],
                stopReason: [
                    { required: true, message: '请选择停用原因', trigger: 'change' },
                ],
            },
            requestConfig: {
                url: '/proxy/api/plan/page',
                method: 'post',
            },
            exportConfig: {
                fileName: '还款计划列表',
                keyUrl: '/proxy/api/plan/export',
                statusUrl: '/proxy/api/getFileUrl',
                statusKeys: 'fileGiftKey',
            },
            defaultSearch: {
                inputSearch: 'driverName',
                repayStatus: '',
            },
            searchConfig: [
                {
                    type: 'inputSearch',
                    key: 'inputSearch',
                    placeholder: '请输入内容',
                    option: [
                        {
                            label: '司机姓名',
                            val: 'driverName',
                        },
                        {
                            label: '合同号',
                            val: 'contractCode',
                        },
                        {
                            label: '手机号',
                            val: 'driverMobile',
                        },
                    ],
                },
                {
                    label: '还款状态',
                    key: 'repayStatus',
                    type: 'radio',
                    option: [
                        {
                            label: '不限',
                            val: '',
                        },
                        {
                            label: '未还清',
                            val: 'PAYING',
                        },
                        {
                            label: '已还清',
                            val: 'PAID_OFF',
                        },
                    ],
                },
                {
                    label: '城市',
                    key: 'cityCode',
                    type: 'select',
                    placeholder: '请选择城市',
                    filterable: true,
                    clearable: true,
                    option: info.cityList,
                },
                {
                    label: '所属公司',
                    key: 'signCompanyName',
                    type: 'select',
                    placeholder: '请选择所属公司',
                    clearable: true,
                    filterable: true,
                    option: info.signCompanyList,
                },
                {
                    label: '结算公司',
                    key: 'settlementCompanyName',
                    type: 'select',
                    clearable: true,
                    placeholder: '请选择结算公司',
                    filterable: true,
                    option: info.settleCompanyList,
                },
                {
                    label: '扣款模式',
                    key: 'deductMode',
                    type: 'select',
                    placeholder: '请选择扣款模式',
                    option: [
                        {
                            label: '不限',
                            val: '',
                        },
                        {
                            label: '日扣平均',
                            val: 'DAY_AVERAGE',
                        },
                        {
                            label: '日扣优先',
                            val: 'DAY_GREED',
                        },
                        {
                            label: '主动还款',
                            val: 'ACTIVE',
                        },
                    ],
                },
                {
                    label: '时间状态',
                    key: 'activeState',
                    type: 'select',
                    placeholder: '请输入时间状态',
                    option: [
                        {
                            label: '不限',
                            val: '',
                        },
                        {
                            label: '未开始',
                            val: 'INACTIVE',
                        },
                        {
                            label: '进行中',
                            val: 'ACTIVE',
                        },
                        {
                            label: '已结束',
                            val: 'TERMINATED',
                        },
                    ],
                },
                {
                    label: '车牌号',
                    key: 'plateNumber',
                    type: 'input',
                    placeholder: '请输入车牌号',
                },
            ],
            tableConfig: [
                {
                    label: '合同号',
                    prop: 'contractCode',
                    tooltip: true,
                    width: '150px',
                    fixed: 'left',
                },
                {
                    label: '时间状态',
                    prop: 'activeState',
                    width: '126px',
                    tooltip: true,
                    formatter: function (val) {
                        var dict = {
                            INACTIVE: '未开始',
                            ACTIVE: '进行中',
                            TERMINATED: '已结束',
                        };
                        return dict[val];
                    },
                },
                {
                    label: '还款状态',
                    prop: 'repayStatus',
                    tooltip: true,
                    width: '126px',
                    formatter: function (val) {
                        return repayStatus[val];
                    },
                },
                {
                    label: '司机姓名',
                    prop: 'driverName',
                    tooltip: true,
                    width: '120px',
                },
                {
                    label: '手机号',
                    prop: 'driverMobile',
                    width: '150px',
                    tooltip: true,
                },
                {
                    label: '费用类型',
                    prop: 'amountType',
                    width: '130px',
                    tooltip: true,
                    formatter: function (val, row) {
                        return amountType[val] || row.amountTypeText || '--';
                    },
                },
                {
                    label: '扣款周期',
                    prop: 'startTime',
                    tooltip: true,
                    width: '240px',
                    sortable: 'custom',
                    sortableUp: 'START_TIME_ASC',
                    sortableDown: 'START_TIME_DESC',
                    formatter: function (val, row) {
                        if (!row.startTime || !row.endTime) {
                            return '--';
                        }
                        return (moment(row.startTime).format('YYYY-MM-DD') +
                            ' 至 ' +
                            moment(row.endTime).format('YYYY-MM-DD'));
                    },
                },
                {
                    label: '扣款模式',
                    prop: 'deductMode',
                    width: '110px',
                    tooltip: true,
                    formatter: function (val) {
                        return deductMode[val];
                    },
                },
                {
                    label: '已还金额(元)',
                    prop: 'paidAmount',
                    align: 'right',
                    width: '130px',
                    tooltip: true,
                    formatter: function (val) {
                        return toYuan(val).toFixed(2);
                    },
                },
                {
                    label: '待还金额(元)',
                    prop: 'waitAmout',
                    align: 'right',
                    width: '130px',
                    tooltip: true,
                    formatter: function (val, row) {
                        return toYuan(row.amount - row.paidAmount).toFixed(2);
                    },
                },
                {
                    label: '车牌号',
                    prop: 'plateNumber',
                    width: '130px',
                    tooltip: true,
                },
                {
                    label: '城市',
                    prop: 'cityName',
                    width: '110px',
                    tooltip: true,
                },
                {
                    label: '所属公司',
                    prop: 'signCompanyName',
                    width: '209px',
                    tooltip: true,
                },
                {
                    label: '结算公司',
                    prop: 'settlementCompanyName',
                    width: '209px',
                    tooltip: true,
                },
                {
                    label: '备注',
                    prop: 'stopDesc',
                    width: '210px',
                    tooltip: true,
                },
                {
                    label: '操作',
                    prop: 'ope_control_group',
                    fixed: 'right',
                    width: '240px',
                    btns: [
                        {
                            name: '修改',
                            formatter: function (row) {
                                var activeState = row.activeState, status = row.status, deductMode = row.deductMode, repayStatus = row.repayStatus;
                                var conditon = status !== 'STOPPED' && repayStatus !== 'PAID_OFF';
                                return (conditon &&
                                    (deductMode === 'ACTIVE' ||
                                        activeState === 'INACTIVE' ||
                                        activeState === 'ACTIVE'));
                            },
                            border: function () {
                                return false;
                            },
                            callback: function (row) {
                                _this.editItem(row);
                            },
                        },
                        {
                            name: '删除',
                            formatter: function (row) {
                                var recordCount = row.recordCount, activeState = row.activeState, status = row.status;
                                if ((recordCount <= 0 && status !== 'STOPPED') ||
                                    activeState === 'INACTIVE') {
                                    return true;
                                }
                                return false;
                            },
                            border: function (row) {
                                var btn = _this.tableConfig[_this.tableConfig.length - 1].btns;
                                return btn[0].formatter(row);
                            },
                            callback: function (row) {
                                _this.deleteItem(row);
                            },
                        },
                        {
                            name: '还款明细',
                            formatter: function (row) {
                                var recordCount = row.recordCount;
                                if (recordCount > 0) {
                                    return true;
                                }
                                return false;
                            },
                            border: function (row) {
                                var btn = _this.tableConfig[_this.tableConfig.length - 1].btns;
                                return btn[0].formatter(row) || btn[1].formatter(row);
                            },
                            callback: function (row) {
                                _this.detailItem(row);
                            },
                        },
                        {
                            name: '停用',
                            formatter: function (row) {
                                var recordCount = row.recordCount, status = row.status, repayStatus = row.repayStatus;
                                if (recordCount > 0 &&
                                    status === 'NORMAL' &&
                                    repayStatus === 'PAYING') {
                                    return true;
                                }
                                return false;
                            },
                            border: function (row) {
                                var btn = _this.tableConfig[_this.tableConfig.length - 1].btns;
                                return (btn[0].formatter(row) ||
                                    btn[1].formatter(row) ||
                                    btn[2].formatter(row));
                            },
                            callback: function (row) {
                                _this.stop(row);
                            },
                        },
                    ],
                },
            ],
            formLabelWidth: '120px',
        };
    },
    created: function () {
        this.getUserName();
        this.$store.dispatch('info/GET_COMPANY_ALL', { type: 'SIGN' });
        this.$store.dispatch('info/GET_COMPANY_ALL', { type: 'SETTLEMENT' });
        this.initPreFilledParam();
    },
    methods: {
        initPreFilledParam: function () {
            var params = this.$route.params;
            for (var item in params) {
                this.preFilledParam[item] = params[item];
                if (item === 'isOverdue') {
                    this.opeBtnActive = 'overdue';
                }
                if (item === 'days') {
                    this.opeBtnActive = 'fail';
                }
            }
        },
        tabOpeBtnActive: function (type) {
            this.opeBtnActive = type;
            var param = {
                isOverdue: false,
                days: '',
            };
            if (type === 'overdue') {
                param.isOverdue = true;
            }
            if (type === 'fail') {
                param.days = '3';
            }
            this.otherParam = param;
        },
        getUserName: function () {
            this.usernameZh = cookie.getCookie('usernameZh');
        },
        getCampaignList: function () { },
        changeYuan: function (value) {
            return toYuan(value);
        },
        changeFen: function (value) {
            return toFen(value);
        },
        stop: function (item) {
            this.currentData = item;
            this.stopForm = {};
            this.amountTips = true;
            this.stopStepActive = 1;
            this.stopStepInnerActive = 1;
            this.stopDialog = true;
            // this.$confirm('', '', {
            //   message: '<p class="title">您确定要停用此计划吗?</p><p class="text">停用后,此还款计划无法恢复</p>',
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonText: '停用',
            //   cancelButtonText: '取消',
            //   type: 'warning',
            //   showClose: false
            // }).then(() => {
            //   request({
            //     method: 'post',
            //     url: '/proxy/api/plan/stop',
            //     data: {
            //       planCode: item.planCode,
            //       // tenant: this.merchantId
            //     }
            //   }).then(res => {
            //     if(!res) return
            //     if (!res.errorCode) {
            //       this.$message(`此计划已停用`)
            //       eventBus.$emit('freshTable')
            //     }
            //   })
            // })
        },
        editItem: function (item) {
            var _this = this;
            this.currentData = item;
            this.editForm.amountTypeText = item.amountTypeText;
            this.editForm.date = [item.startTime, item.endTime];
            this.editForm.amount = toYuan(item.amount);
            this.editForm.mode = item.deductMode;
            this.dialogFormVisible = true;
            this.paidAmount = item.paidAmount;
            this.option.forEach(function (optionItem) {
                if (optionItem.value === 'DAY_GREED' ||
                    optionItem.value === 'DAY_AVERAGE') {
                    if (item.amountType === 'MONTHLY_RENT') {
                        optionItem.disabled = false;
                    }
                    else {
                        optionItem.disabled = true;
                    }
                }
            });
            setTimeout(function () {
                _this.$refs['editForm'].validate(function (valid) {
                    if (!valid) {
                        return false;
                    }
                });
            }, 0);
        },
        deleteItem: function (item) {
            var _this = this;
            this.$confirm('', '', {
                message: "<p class=\"title\">\u63D0\u793A</p><p class=\"text\">\u60A8\u786E\u8BA4\u8981\u5220\u9664\u8BE5\u8FD8\u6B3E\u8BA1\u5212\u5417\uFF1F</p>",
                dangerouslyUseHTMLString: true,
                customClass: 'remove-repayment-dialog',
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                type: 'warning',
                showClose: false,
            })
                .then(function () {
                request({
                    method: 'post',
                    url: '/proxy/api/plan/delete',
                    data: {
                        planCode: item.planCode,
                    },
                }).then(function (res) {
                    if (!res) {
                        return;
                    }
                    if (!res.errorCode) {
                        _this.$message("\u6B64\u8BA1\u5212\u5DF2\u5220\u9664");
                        eventBus.$emit('freshTable');
                    }
                });
            })
                .catch(function () { });
        },
        detailItem: function (item) {
            this.$router.push({
                name: 'repaymentDetails',
                params: { planCode: item.planCode },
            });
        },
        saveEPlan: function () {
            var _this = this;
            this.$refs['editForm'].validate(function (valid) {
                if (!valid) {
                    return;
                }
                var time = {};
                var param = {
                    planCode: _this.currentData.planCode,
                    contractCode: _this.currentData.contractCode,
                    mode: _this.editForm.mode,
                    amount: toFen(_this.editForm.amount),
                    operator: _this.usernameZh,
                };
                if (!_this.isActive) {
                    time = Object.assign({}, {
                        startTime: _this.editForm.date[0],
                        endTime: _this.editForm.date[1],
                    });
                }
                var data = Object.assign({}, param, time);
                request({
                    method: 'post',
                    url: '/proxy/api/plan/edit',
                    data: data,
                }).then(function (res) {
                    if (!res) {
                        return;
                    }
                    if (!res.errorCode) {
                        _this.dialogFormVisible = false;
                        _this.$message({
                            message: '修改成功',
                            type: 'success',
                        });
                        eventBus.$emit('freshTable');
                    }
                });
            });
        },
        stopSubmit: function () {
            var _this = this;
            this.$refs['stopForm'].validate(function (valid) {
                if (_this.stopStepActive === 2) {
                    _this.amountTips = false;
                }
                if (!valid) {
                    return;
                }
                if (_this.stopStepActive === 1) {
                    _this.stopStepInnerActive =
                        _this.stopForm.stopReason === 'stopDown' ? 1 : 2;
                    _this.stopStepActive = 2;
                }
                else {
                    if (_this.stopStepInnerActive === 3) {
                        var isOfflineRepay = _this.stopForm.stopReason === 'stopDown';
                        var data = {
                            planCode: _this.currentData.planCode,
                            stopReason: isOfflineRepay
                                ? moment(_this.stopForm.date).format('YYYY-MM-DD') + " \u7EBF\u4E0B\u8FD8\u6B3E" + _this.stopForm.stopAmount + "\u5143"
                                : _this.stopForm.reason,
                            repayAmount: isOfflineRepay ? toFen(_this.stopForm.stopAmount) : 0,
                            repayTime: isOfflineRepay
                                ? moment(_this.stopForm.date).format('YYYY-MM-DD HH:mm:ss')
                                : '',
                            isOfflineRepay: isOfflineRepay,
                        };
                        request({
                            method: 'post',
                            url: '/proxy/api/plan/stop',
                            data: data,
                        }).then(function (res) {
                            if (!res) {
                                return;
                            }
                            if (!res.errorCode) {
                                _this.$message("\u8FD8\u6B3E\u8BA1\u5212\u505C\u7528\u6210\u529F");
                                eventBus.$emit('freshTable');
                                _this.stopDialog = false;
                                return;
                            }
                            _this.$message.error(res.errorMsg);
                        });
                    }
                    _this.stopStepInnerActive = 3;
                }
            });
        },
        isShowTips: function () {
            this.amountTips = false;
        },
    },
    watch: {
        cityList: function (val) {
            this.searchConfig[2].option = val;
        },
        signCompanyList: function (val) {
            if (val instanceof Array) {
                val[0] && val[0].clearSelf === '_NODATA_SIGN' ? val.splice(0, 1) : '';
                return (this.searchConfig[3].option = val);
            }
            this.searchConfig[3].option = [];
        },
        settleCompanyList: function (val) {
            if (val instanceof Array) {
                val[0] && val[0].clearSelf === '_NODATA_SETTLEMENT'
                    ? val.splice(0, 1)
                    : '';
                return (this.searchConfig[4].option = val);
            }
            this.searchConfig[4].option = [];
        },
    },
});
